<template>
    <footer>
        <ul>
            <li>
                <a href="https://skeepers.io/fr/" target="_blank">{{ config.FOOTER_POWERED_BY }}</a>
            </li>
            <li>
                <a :href="config.FOOTER_LEGAL_URL" target="_blank">{{ config.FOOTER_LEGAL }}</a>
            </li>
            <li>
                <a :href="config.FOOTER_TOS_URL" target="_blank">{{ config.FOOTER_TOS }}</a>
            </li>
            <li>
                <a :href="config.FOOTER_PRIVACY_URL" target="_blank">{{ config.FOOTER_PRIVACY }}</a>
            </li>
        </ul>
    </footer>
</template>
<script>
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'Footer',
    mixins: [SolutionConsumer],
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';
@import '../../assets/scss/variables';

footer {
    padding: 12px;
    box-shadow: 0 -6px 6px 0 rgba($black, .05);
    font-family: $font-title;
    font-size: 12px;
    background-color: $white;
    color: $grey-dark;
    user-select: none;
    white-space: nowrap;
    overflow: auto;
    z-index: 1;

    > ul {
        @include ul-horizontal(20px);
        margin: 0 auto;
        width: min-content;
    }

    a {
        text-decoration: none;
        color: inherit;
    }
}
</style>
